type PaymentIssuer = {
  idType: string;
  idNumber: string;
  names: string;
  lastNames: string;
  email: string;
  phoneNumber: string;
  birthday: string;
  gender: string;
};
export default PaymentIssuer;

export function makeEmptyPaymentIssuer(): PaymentIssuer {
  return {
    idType: '',
    idNumber: '',
    names: '',
    lastNames: '',
    email: '',
    phoneNumber: '',
    birthday: '',
    gender: '',
  };
}
